<script>

import vue2Dropzone from 'vue2-dropzone'
import Multiselect from 'vue-multiselect'

export default {

	components: { Multiselect, vueDropzone: vue2Dropzone },
    props: {
        type: { type: String, default: null }
    },
	data() {
        return {
            dropzoneOptions: {
                url: 'https://api.client.za-bota.com/v1/imports/upload/',
                thumbnailWidth: 30,
                maxFilesize: 10,
                params: {
                    'type': 'contacts',
                    'token': ''
                }
            },
            dropzoneShow: true,

            showForm: false,
            trackBy: 'id',

            status: '',
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'Ожидает активации'},
                {id: 'blocked', name: 'Заблокирован'},
            ],

            contact_category: null,
            contact_category_options: [],

            file_path: null,
            file_name: null,

            fullname: null,
            fullname_options: [],

            name1: null,
            name1_options: [],

            name2: null,
            name2_options: [],

            name3: null,
            name3_options: [],

            phone: null,
            phone_options: [],

            email: null,
            email_options: [],

            company: null,
            company_options: [],

            inn: null,
            inn_options: [],

            city: null,
            city_options: [],

            source: null,
            source_options: [],

            qnt: 0,

            isAdmin: false,

            isSubmitErrorData: null,
            alertMessage: null,
            alertVariant: null,

            all_fields: false
		}
	},

	computed: {
        contacts_categories_list_data(){            
            return this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        if(this.type === null){
            await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {'sortBy': 'id', 'sortDesc': 'DESC'});
            this.contact_category_options = this.contacts_categories_list_data;
        }

        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            this.isAdmin = true;
        }

        this.dropzoneOptions.params.token = window.localStorage.getItem('API_KEY_ZABOTA');
	},

	methods: {

        async importData(category_id = null){

            let err = false;
            let err_message = '';

            if(!this.phone || !this.phone.id){
                err = true;
                err_message = 'Номер телефона';
            }

            if(category_id === null && (!this.contact_category || !this.contact_category.id || this.contact_category === null)){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Группа контактов';
            }

            if(err === true){
                this.isSubmitErrorData = true;
                this.alertMessage = 'Не все обязательные поля были заполнены: ' + err_message;
                this.alertVariant = 'danger';
                
                return false;
            }

            let data_import = {
                'indx' : {
                    'fullname': this.fullname && this.fullname.id ? this.fullname.id - 1 : '',
                    'name1': this.name1 && this.name1.id ? this.name1.id - 1 : '',
                    'name2': this.name2 && this.name2.id ? this.name2.id - 1 : '',
                    'name3': this.name3 && this.name3.id ? this.name3.id - 1 : '',
                    'phone': this.phone && this.phone.id ? this.phone.id - 1 : '',
                    'email': this.email && this.email.id ? this.email.id - 1 : '',
                    'company': this.company && this.company.id ? this.company.id - 1 : '',
                    'inn': this.inn && this.inn.id ? this.inn.id - 1 : '',
                    'source': this.source && this.source.id ? this.source.id - 1 : '',
                    'city': this.city && this.city.id ? this.city.id - 1 : '',
                },
                'params' : {
                    'owner_id': this.session_user_item && this.session_user_item.id ? this.session_user_item.id : '',
                    'status': this.status && this.status.id ? this.status.id : 'active',
                    'category_id': this.contact_category && this.contact_category.id ? this.contact_category.id : '',
                }
            };

            // console.log(data_import);

            if(category_id !== null){
                data_import.params.category_id = category_id;
            }

            if(this.file_path !== null) {

                let data_send = {
                    'name' : 'contacts',
                    'qnt' : this.qnt,
                    'status' : 'wait',
                    'more_data': JSON.stringify(data_import),
                    'filename' : this.file_name,
                    'filepath' : this.file_path
                };

                let response = await this.$store.dispatch('imports/FETCH_IMPORTS_CREATE', data_send);

                if (response === false) {
                    alert('При загрузке возникла ошибка');
                    this.$refs.myVueDropzone.removeAllFiles();
                } else {
                    if(this.type === null){
                        this.$router.push({name: 'Imports.Contacts'});   
                    }
                    return !err;
                }

            } else {
                alert('При загрузке возникла ошибка');
                this.$refs.myVueDropzone.removeAllFiles();
                return false;
            }
        },

        uploadSuccess(file, response) {

            response = JSON.parse(response);
            
            this.$refs.myVueDropzone.removeAllFiles();

            if(response && response.status === 'success') {

                let options_arr = [];
                let i = 1;
                let data_arr = response.data.columns;

                data_arr.forEach(el => {
                    options_arr.push({
                        id: i,
                        name: el,
                    });
                    i++;
                });

                this.fullname_options = options_arr;
                this.name1_options = options_arr;
                this.name2_options = options_arr;
                this.name3_options = options_arr;
                this.phone_options = options_arr;
                this.email_options = options_arr;
                this.company_options = options_arr;
                this.inn_options = options_arr;
                this.city_options = options_arr;
                this.source_options = options_arr;
                this.file_name = response.data && response.data.filename ? response.data.filename : '';
                this.file_path = response.data && response.data.filepath ? response.data.filepath : '';

                this.showForm = true;

            } else {
                alert('При загрузке возникла ошибка');
                return false;
            }
        },

        uploadError(file, message) {

        },
	}
}

</script>

<template>
    <div>
        <!-- file upload -->
        <vue-dropzone
            v-show="dropzoneShow"
            id="dropzone"
            ref="myVueDropzone"
            @vdropzone-success="uploadSuccess"
            @vdropzone-error="uploadError"
            :options="dropzoneOptions"
            :use-custom-slot="true"
        >
            <div class="text-center">
                <i class="h1 text-muted uil-cloud-upload"></i>
                <h3 style="font-size: 20px; line-height: 130%">Перетащите файл или нажмите для загрузки</h3>
                <span class="text-muted font-size-13">
                    Поддерживаемые форматы: <strong>*.xls, *.xlsx, *.csv</strong>
                </span>
            </div>
        </vue-dropzone>

        <h3 v-show="showForm" style="font-size: 16px; line-height: 130%; margin-top: 40px">Укажите соответствие полей:</h3>

        <b-form
            v-show="showForm"
            class="form-horizontal"
            style="margin-top: 30px"
        >
            <div class="row">
                <div class="col">
                    <b-alert
                        v-model="isSubmitErrorData"
                        :variant="alertVariant"
                        dismissible
                    >{{ alertMessage }}</b-alert>                                
                </div>
            </div>

            <div v-if="type === null" class="row" style="margin-bottom: 20px">
                <div class="col">
                    <span style="font-weight: bold">* - поля обязательные к заполнению</span>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    
                    <div style="margin-bottom: 15px">
                        <label for="contact_category">Укажите колонку с номерами телефонов *
                            <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Заголовок колонки с номерами телефонов из файла, загруженного для текущего обзвона'">?</a>
                        </label>
                        <multiselect
                            id="phone"
                            v-model="phone"
                            :options="phone_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </div>
                    <b-form-checkbox v-model="all_fields" name="all_fields" style="margin-top: 5px; margin-bottom: 15px" switch>
                        Показать расширенный список полей <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Функция нужна, если загруженная база содержит дополнительные поля (например, ФИО) для добавления в скрипт этой информации'">?</a>
                    </b-form-checkbox>

                    <b-form-group
                        v-if="all_fields"
                        label="Компания"
                    >
                        <multiselect
                            id="company"
                            v-model="company"
                            :options="company_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="ИНН"
                    >
                        <multiselect
                            id="inn"
                            v-model="inn"
                            :options="inn_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="Город"
                    >
                        <multiselect
                            id="city"
                            v-model="city"
                            :options="city_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="Источник"
                    >
                        <multiselect
                            id="source"
                            v-model="source"
                            :options="source_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="ФИО"
                    >
                        <multiselect
                            id="fullname"
                            v-model="fullname"
                            :options="fullname_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>


                    <b-form-group
                        v-if="all_fields"
                        label="Имя"
                    >
                        <multiselect
                            id="name1"
                            v-model="name1"
                            :options="name1_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="Отчество"
                    >
                        <multiselect
                            id="name2"
                            v-model="name2"
                            :options="name2_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="all_fields"
                        label="Фамилия"
                    >
                        <multiselect
                            id="name3"
                            v-model="name3"
                            :options="name3_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>                    

                    <b-form-group
                        v-if="all_fields"
                        label="E-mail"
                    >
                        <multiselect
                            id="email"
                            v-model="email"
                            :options="email_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="type === null"
                        label="Группа контактов*"
                        label-for="contact_category"
                    >
                        <multiselect
                            id="contact_category"
                            v-model="contact_category"
                            :options="contact_category_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="isAdmin && type === null"
                        label="Статус"                                        
                    >
                        <multiselect
                            id="status"
                            v-model="status"
                            :options="status_options"
                            placeholder="Выберите из списка"
                            selectLabel="Нажмите, чтобы выбрать"
                            deselectLabel="Нажмите, снять выделение"
                            label="name"
                            :track-by="trackBy"
                        ></multiselect>
                    </b-form-group>

                    <b-form-group
                        v-if="type === null"
                        style="margin-top: 30px"
                    >
                        <button type="button" @click="importData()" class="btn btn-primary">Импортировать</button>
                    </b-form-group>

                </div>
            </div>
        </b-form>
    </div>
</template>

<style>
    .dz-preview {
        padding: 15px
    }
    .dz-progress {
        display: none;
    }
    .dz-success-mark, .dz-error-mark {
        display: none;
    }
</style>